import { CreateProduct, Product, UpdateProduct } from '@/entities/product';
import { ProductService } from '@/services/ProductService';
import { useEffect, useState } from 'react';

export function useProduct(){
  const [productsUse, setProducts] = useState<Product[]>([]);
  const [moduleUse, setModules] = useState<Product[]>([]);
  const [fetchProductError, setFetchProductError] = useState(false);
  const [ getProductsError, setGetProductsError] = useState(false);
  const [ createProductError, setCreateProductError ] = useState(false);
  const [open, setOpen] = useState(false);
  const [editProduct, setEditProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [ idToEdit, setIdToEdit ] = useState<number>(NaN);
  
  const fetchProduct = async () =>{
    try{
      getAllProducts();
    }catch(error){
      console.error('Falha ao carregar dados de produtos: ', error);
      setFetchProductError(true);
    }
  };
  
  useEffect(()=>{
    getAllmodule();
    fetchProduct();
  }, []);

  const getAllModulesByBusiness = async (businessId: number) => {
    try {
      const response  = await ProductService.getAllModulesByBusiness(businessId);
      if(response){
        return response;
      }
    } catch (e){
      console.error(e);
    }
    }

  const getAllmodule = async () => {
    try {
      const response = await ProductService.getAllmodule();
      if(response){
        const products = response.map((data) =>({
          id:data.id,
          name:data.name,
          description:data.description,
          price:data.price,
          deploy: data.deploy,
          commission: data.commission,
        })).sort((a, b) => a.id - b.id);
        setModules(products);
        return response;
      }
    } catch(error){
      console.error('Falha ao carregar dados de produtos: ', error);
      setGetProductsError(true);
    }
  }

  const getAllProducts = async () =>{
    try{
      const response = await ProductService.getAllProduct();
      if(response){
        const products = response.map((data) =>({
          id:data.id,
          name:data.name,
          description:data.description,
          price:data.price,
          deploy: data.deploy,
          commission: data.commission,
        })).sort((a, b) => a.id - b.id);
        setProducts(products);
      }
    }catch(error){
      console.error('Falha ao carregar dados de produtos: ', error);
      setGetProductsError(true);
    }
  };

  const getAllProducts2 = async ():Promise<Product[] | null> =>{
    try{
      const response = await ProductService.getAllProduct();
      if(response){
        const products = response.map((data) =>({
          id:data.id,
          name:data.name,
          description:data.description,
          price:data.price,
          commission: data.commission,
          deploy: data.deploy,
        })).sort((a, b) => a.id - b.id);
        return products;
      }
      return null;
    }catch(error){
      console.error('Falha ao carregar dados de produtos: ', error);
      setGetProductsError(true);
      return null;
    }
  };

  const createProduct = async (product: CreateProduct): Promise<Product | null> => {
    try {
      const response = await ProductService.createProduct(product);
      if (response) {
        return response;
      }
    } catch (error) {
      console.error('Falha ao criar produto: ', error);
      setCreateProductError(true);
    }
    return null; 
  };
  
  const updateProduct = async (productId:number, product: UpdateProduct) => {
    try{
      await ProductService.updateProduct(productId, product);
      fetchProduct();
    }catch(error){
      console.error('Falha ao atualizar produtos: ', error);
    }
  };

  const deleteProduct = async (id:number) => {
    try{
      await ProductService.deleteProduct(id);
    }catch(error){
      console.error('Falha ao deletar produtos: ', error);
    }
  };

  return {
    productsUse,
    fetchProductError,
    createProductError,
    selectedProduct,
    open,
    editProduct,
    idToEdit,
    getAllmodule,
    moduleUse,
    setModules,
    setSelectedProduct,
    createProduct,
    updateProduct,
    deleteProduct,
    setOpen,
    getAllModulesByBusiness,
    setEditProduct,
    setIdToEdit,
    getAllProducts2
  };
}
